import accounting from "accounting";

export default {
  state: {
    userBalance: null, // Баланс пользователя в разлиных валютах. Баланс - сумма цен бумаг в портфеле и сумма денежных средств
    currencyPortfolio: null, // Валютный портфель пользователя
    totalMoneyInTenge: null // Сумма денежных средств пользователя в Тенге
  },
  actions: {},
  mutations: {
    setTotalMoneyInTenge(state, totalMoneyInTenge) {
      state.totalMoneyInTenge = totalMoneyInTenge;
    },
    unsetTotalMoneyInTenge(state) {
      state.totalMoneyInTenge = null;
    },
    setCurrencyPortfolio(state, currencyPortfolio) {
      // Отлавливаем ошибку, при которой сервер не возвращает данные
      if (!Array.isArray(currencyPortfolio)) {
        currencyPortfolio = [];
      }
      state.currencyPortfolio = currencyPortfolio;
    },
    unsetCurrencyPortfolio(state) {
      state.currencyPortfolio = null;
    },
    setUserBalance(state, balance) {
      state.userBalance = balance;
    },
    unsetUserBalance(state) {
      state.userBalance = null;
    }
  },
  getters: {
    // Возвращает объект с балансом в разных валютах
    userBalance(state) {
      return state.userBalance || {};
    },
    isUserBalanceLoading(state) {
      return state.userBalance === null;
    },
    currencyPortfolio(state) {
      return state.currencyPortfolio;
    },
    isCurrencyPortfolioLoading(state) {
      return state.currencyPortfolio === null;
    },
    totalMoneyInTenge(state) {
      return state.totalMoneyInTenge;
    },
    totalMoneyInSelectedCurrency(state, getters) {
      let currencyRate = getters.rate;
      let displayingCurrency = getters.displayingCurrency;
      return accounting.formatMoney(
        state.totalMoneyInTenge / currencyRate[displayingCurrency],
        "",
        0,
        " ",
        "."
      );
    },
    // Возвращаем текущий общий баланс по выбранной валюте
    currentBalance(state, getters) {
      let userBalance = state.userBalance || {};
      if (userBalance[getters.displayingCurrency] !== undefined) {
        let balance = userBalance[getters.displayingCurrency].balance;
        return accounting.formatMoney(balance, "", 0, " ", ".");
        // Пока данные загружаются с сервера, отображаем "0"
      } else {
        return 0;
      }
    },
    // Возвращаем функцию, которая принимает валюту и возвращает баланс в данной валюте
    balanceByCurrency(state) {
      let userBalance = state.userBalance || {};
      return currency => {
        if (userBalance[currency] !== undefined) {
          let balance = userBalance[currency].balance;
          return accounting.formatMoney(balance, "", 0, " ", ".");
          // Пока данные загружаются с сервера, отображаем "0"
        } else {
          return 0;
        }
      };
    },
    // Возвращаем свободные средства
    freeAmount(state, getters) {
      let userBalance = state.userBalance || {};
      if (userBalance[getters.displayingCurrency] !== undefined) {
        let freeAmount = userBalance[getters.displayingCurrency].free_amount;
        return accounting.formatMoney(freeAmount, "", 2, " ", ".");
        // Пока данные загружаются с сервера, отображаем "0"
      } else {
        return 0;
      }
    },
    blockedAmount(state, getters) {
      let userBalance = state.userBalance || {};
      if (userBalance[getters.displayingCurrency] !== undefined) {
        let blockedAmount =
          userBalance[getters.displayingCurrency].blocked_amount;
        return accounting.formatMoney(blockedAmount, "", 0, " ", ".");
        // Пока данные загружаются с сервера, отображаем "0"
      } else {
        return 0;
      }
    },
    totalAmount(state, getters) {
      let userBalance = state.userBalance || {};
      if (userBalance[getters.displayingCurrency] !== undefined) {
        let freeAmount = userBalance[getters.displayingCurrency].free_amount;
        let blockedAmount =
          userBalance[getters.displayingCurrency].blocked_amount;
        // console.log(parseFloat(blockedAmount));
        let totalAmount = parseFloat(freeAmount) + parseFloat(blockedAmount);
        return accounting.formatMoney(totalAmount, "", 0, " ", ".");
        // Пока данные загружаются с сервера, отображаем "0"
      } else {
        return 0;
      }
    },
    // Возвращает список из валют, которые имеются у пользователя
    currenciesOfUser(state, getters) {
      let currencyPortfolio = getters.currencyPortfolio;
      // Проверяем, пришли ли данные с сервера
      if (!currencyPortfolio) {
        return [];
      }
      let currencies = [];
      // Проходим по списку денег пользователя и на каждой итерации проверяем, имеется ли данная валюта у нас в списке. Если ее нет, добавляем
      currencyPortfolio.forEach(item => {
        if (!currencies.includes(item.CURRENCY)) {
          currencies.push(item.CURRENCY);
        }
      });
      return currencies;
    }
  }
};
